import { Pipe, PipeTransform } from '@angular/core';

import { BehaviorScreen } from '../models/view-models/monitor-models/screen.type';
import { Machine } from '../models/entities/machine.type';
import { ScreensStateService } from '../services/screen-state/screens-state.service';
import { MachineCategory } from '../models/entities/machine-category.type';

@Pipe({
  name: 'monitorFilter'
})
export class MonitorFilterPipe implements PipeTransform {

  constructor(private screenStateService: ScreensStateService) { }

  transform(monitors: Partial<BehaviorScreen>[], location: Machine, filterString: string, categories?: MachineCategory[]) {
    if (!monitors || !monitors.length) {
      this.screenStateService.monitorsInTheDashboard.next([]);
      this.screenStateService.filteredMonitorsInTheDashboard.next([]);
      return [];
    }

    if (!location) {
      return this.getFilteredByString(monitors, filterString);
    }

    const filteredByCategory = categories?.length && categories.every(category => category.Id) ?
      this.filterByCategory(monitors, categories) :
      monitors;

    if (!location.PhysicalAddress) {
      const filteredByPhysicalAddress = filteredByCategory.filter((screen) =>
        screen.IsPrimary ? screen.Machine.ShowPrimaryScreen : true
      );

      return this.getFilteredByString(filteredByPhysicalAddress, filterString);
    }

    const filtered = filteredByCategory.filter(
      (screen) =>
        screen.MachinePhysicalAddress === location.PhysicalAddress &&
        (screen.IsPrimary ? screen.Machine.ShowPrimaryScreen : true)
    );

    return this.getFilteredByString(filtered, filterString);
  }

  private getFilteredByString(monitors: Partial<BehaviorScreen>[], filter: string): Partial<BehaviorScreen>[] {
    let result: Partial<BehaviorScreen>[];
    if (!filter) {
      result = monitors;
    } else {
      result = monitors.filter(monitor => monitor.MonitorTitle.toLowerCase().includes(filter.trim().toLowerCase()));
    }

    const sortedMonitorsByAsc = result.sort((monitorA, monitorB) =>
      monitorA.MonitorTitle.localeCompare(monitorB.MonitorTitle, undefined, {numeric: true, sensitivity: 'base'}));

    this.screenStateService.monitorsInTheDashboard.next(sortedMonitorsByAsc as BehaviorScreen[]);
    this.screenStateService.filteredMonitorsInTheDashboard.next(sortedMonitorsByAsc as BehaviorScreen[]);
    return sortedMonitorsByAsc;
  }

  private filterByCategory(monitors: Partial<BehaviorScreen>[], categories: MachineCategory[]): Partial<BehaviorScreen>[] {
    return monitors.filter(screen =>
      categories.length ?
        categories.some(category => category.Id === screen.Machine.CategoryId) :
        true);
  }
}
